import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'tix-venue-map',
  templateUrl: './venue-map.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VenueMapComponent implements OnInit {
  @Input() formattedAddress: string;

  embedUrl: SafeResourceUrl;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.embedUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
      `https://maps.google.com/maps?q=${this.formattedAddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`
    );
  }
}
